import { createAction } from "@reduxjs/toolkit";

// Define Action Types for Image Selection Question
export const ACTION_TYPES = {
  UPDATE_SELECTED_HOTSPOT: "UPDATE_SELECTED_HOTSPOT",
};

// Define action creators using createAction
export const updateSelectedHotspot = createAction(
  ACTION_TYPES.UPDATE_SELECTED_HOTSPOT,
  (hotspotID) => ({ payload: { hotspotID } })
);
